// JALE wordmark — industrial nameplate style.
// Bebas Neue (loaded in public/index.html) + brand yellow with two
// hazard-stripe accents on the right edge to give it a construction-y feel.
//
// Variants:
//   size:    "sm" | "md" | "lg"
//   tone:    "yellow" (default) | "ink" (yellow on yellow bg, etc — letters become ink)
//   stripes: true (default) | false  — toggle the side accent
import React from "react";

const SIZES = {
  sm: "text-xl",
  md: "text-3xl",
  lg: "text-5xl md:text-6xl",
};

const STRIPE_SIZES = {
  sm: "w-3",
  md: "w-4",
  lg: "w-6",
};

export default function Logo({ size = "md", tone = "yellow", stripes = true, className = "" }) {
  const letterColor = tone === "ink" ? "text-brand-ink" : "text-brand-yellow";
  const stripeColor = tone === "ink" ? "bg-brand-ink" : "bg-brand-yellow";

  return (
    <span className={`inline-flex items-center gap-2 select-none leading-none ${className}`}>
      <span
        className={`font-display tracking-[0.12em] ${SIZES[size]} ${letterColor}`}
        style={{ lineHeight: 0.9 }}
      >
        JALE
      </span>
      {stripes && (
        <span className="hidden xs:flex flex-col gap-0.5 sm:flex">
          <span className={`block h-[3px] ${STRIPE_SIZES[size]} ${stripeColor}`} />
          <span className={`block h-[3px] ${STRIPE_SIZES[size]} ${stripeColor} opacity-60`} />
          <span className={`block h-[3px] ${STRIPE_SIZES[size]} ${stripeColor} opacity-30`} />
        </span>
      )}
    </span>
  );
}
